
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 267 267"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"carousel-clip-path"}},[_c('circle',{staticClass:"carousel-cls-1",attrs:{"cx":"133.5","cy":"133.5","r":"133.5"}})])]),_c('g',{attrs:{"id":"carousel-Layer_2","data-name":"Layer 2"}},[_c('g',{attrs:{"id":"carousel-Layer_2-2","data-name":"Layer 2"}},[_c('circle',{staticClass:"carousel-cls-1",attrs:{"cx":"133.5","cy":"133.5","r":"133.5"}}),_c('g',{attrs:{"clip-path":"url(#carousel-clip-path)"}},[_c('path',{staticClass:"carousel-cls-1",attrs:{"d":"M0 0h267v267H0z"}})]),_c('path',{attrs:{"d":"M174.93 153.68c-5.89 15.28-18.37 23-38.31 23-28.36 0-44.95-15.91-44.95-43.17 0-27.89 16.59-43.17 46.32-43.17 23.63 0 37.34 8.24 37.34 22.36 0 8.46-4.87 12.75-14.87 12.75-9.58 0-14.66-4.13-14.66-11.77a60.28 60.28 0 01.77-6.47 32.62 32.62 0 00.6-5.92c0-4.55-3.29-7.44-8.21-7.44-11 0-15.84 12.19-15.84 38.68 0 27.26 6.84 39.66 21.87 39.66 11.71 0 20.34-6.69 26-20z","fill":"#ffe4e0","fill-rule":"evenodd"}})])])])
          )
        }
      }
    